import React from 'react';
import { Flame, ShieldCheck, HeadphonesIcon, Fuel } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
const services = [{
  title: 'Combustibles de Calidad',
  description: 'Distribuimos GLP, Gasolina y Gasoil de la más alta calidad. Nuestra gasolina es suministrada en colaboración con NEXT, garantizando un producto premium que mejora el rendimiento y reduce emisiones.',
  icon: Fuel,
  color: '#FCEE02'
}, {
  title: 'Servicio al Cliente Superior',
  description: 'Nos enorgullecemos de ofrecer un servicio al cliente excepcional. Nuestro equipo capacitado está comprometido a satisfacer sus necesidades de combustible y responder a sus consultas con prontitud y profesionalismo.',
  icon: HeadphonesIcon,
  color: '#FB900D'
}, {
  title: 'Seguridad y Confianza',
  description: 'La seguridad de nuestros clientes es nuestra principal prioridad. Implementamos rigurosos estándares de seguridad y control de calidad para garantizar que cada transacción de combustible sea segura y confiable.',
  icon: ShieldCheck,
  color: '#EC2424'
}];
export function ServicesSection() {
  return <section className="py-16 sm:py-24 relative overflow-hidden transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-378">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'linear-gradient(#FCEE02 1px, transparent 1px), linear-gradient(90deg, #FCEE02 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-379" />

      <div className="container mx-auto px-4 sm:px-6 md:px-12 relative z-10" data-id="element-380">
        <AnimateOnScroll className="mb-12 sm:mb-16 max-w-3xl" data-id="element-381">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter mb-6 transition-colors duration-300" style={{
          color: 'var(--text-primary)'
        }} data-id="element-382">
            Nuestros{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FCEE02] to-[#FB900D]" data-id="element-383">
              Servicios
            </span>
          </h2>
          <p className="text-lg sm:text-xl border-l-4 border-[#EC2424] pl-4 sm:pl-6 transition-colors duration-300" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-384">
            Comprometidos con ofrecer productos de la más alta calidad y un
            servicio excepcional a nuestros clientes.
          </p>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-385">
          {services.map((service, index) => <AnimateOnScroll key={index} delay={index * 0.15} direction="up" data-id="element-386">
              <div className="group p-6 sm:p-8 border hover:border-[#FCEE02] transition-all duration-300 relative overflow-hidden h-full rounded-xl" style={{
            backgroundColor: 'var(--card-bg)',
            borderColor: 'var(--border-color)'
          }} data-id="element-387">
                <div className="absolute top-0 left-0 w-full h-1 transition-transform duration-300 origin-left scale-x-0 group-hover:scale-x-100 rounded-t-xl" style={{
              backgroundColor: service.color
            }} data-id="element-388" />

                <div className="flex justify-between items-start mb-6 sm:mb-8" data-id="element-389">
                  <div className="p-3 border group-hover:border-white/20 transition-colors rounded-lg" style={{
                backgroundColor: 'var(--bg-primary)',
                borderColor: 'var(--border-color)'
              }} data-id="element-390">
                    <service.icon className="w-7 h-7 sm:w-8 sm:h-8" style={{
                  color: service.color
                }} strokeWidth={1.5} data-id="element-391" />
                  </div>
                  <span className="text-gray-500 font-mono text-sm" data-id="element-392">
                    0{index + 1}
                  </span>
                </div>

                <h3 className="text-xl sm:text-2xl font-bold uppercase mb-4 group-hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-primary)'
            }} data-id="element-393">
                  {service.title}
                </h3>

                <p className="leading-relaxed text-sm sm:text-base transition-colors duration-300" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-394">
                  {service.description}
                </p>

                <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-current opacity-5 rotate-45 transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500" style={{
              color: 'var(--text-primary)'
            }} data-id="element-395" />
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}